const TZ = 'Europe/Istanbul';

const dateFmt = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', timeZone: TZ });
const dateYearFmt = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: TZ });
const timeFmt = new Intl.DateTimeFormat('tr-TR', { hour: '2-digit', minute: '2-digit', timeZone: TZ });
const weekdayFmt = new Intl.DateTimeFormat('tr-TR', { weekday: 'long', timeZone: TZ });
const shortDayFmt = new Intl.DateTimeFormat('tr-TR', { weekday: 'short', timeZone: TZ });
const numFmt = new Intl.NumberFormat('tr-TR');

export function fmtDate(d: string | Date): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return date.getFullYear() === new Date().getFullYear() ? dateFmt.format(date) : dateYearFmt.format(date);
}

export function fmtTime(d: string | Date): string {
  return timeFmt.format(typeof d === 'string' ? new Date(d) : d);
}

export function fmtDateTime(d: string | Date): string {
  return `${fmtDate(d)} · ${fmtTime(d)}`;
}

export function fmtWeekday(d: string | Date): string {
  const s = weekdayFmt.format(typeof d === 'string' ? new Date(d) : d);
  return s.charAt(0).toLocaleUpperCase('tr-TR') + s.slice(1);
}

export function fmtShortDay(d: Date): string {
  return shortDayFmt.format(d).replace('.', '');
}

export function fmtNumber(n: number | string): string {
  const v = typeof n === 'string' ? Number(n) : n;
  return Number.isFinite(v) ? numFmt.format(Math.round(v)) : String(n);
}

/** "3 gün kaldı" / "bugün bitiyor" — ödül/teklif son kullanım. */
export function fmtRemaining(until: string | Date | null | undefined): string | null {
  if (!until) return null;
  const ms = new Date(until).getTime() - Date.now();
  if (ms <= 0) return 'Süresi doldu';
  const days = Math.floor(ms / 86_400_000);
  if (days === 0) return 'Bugün bitiyor';
  if (days === 1) return 'Yarın bitiyor';
  if (days < 30) return `${days} gün kaldı`;
  return `${fmtDate(until)} tarihine kadar`;
}

/** Günün saatine göre selam. */
export function greeting(now = new Date()): string {
  const h = Number(new Intl.DateTimeFormat('tr-TR', { hour: 'numeric', hour12: false, timeZone: TZ }).format(now));
  if (h < 5) return 'İyi geceler';
  if (h < 12) return 'Günaydın';
  if (h < 18) return 'İyi günler';
  return 'İyi akşamlar';
}

export function firstName(fullName: string | null | undefined): string | null {
  const s = fullName?.trim();
  if (!s) return null;
  return s.split(/\s+/)[0];
}
